import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { api } from "@/lib/api"

interface ApiToken {
  id: string
  name: string
  lastUsedAt: string | null
  expiresAt: string | null
  scope: "full" | "read"
  createdAt: string
}

export interface CreateTokenInput {
  name: string
  /** "read" tokens can only make GET requests. */
  scope?: "full" | "read"
  expiresInDays?: number
}

interface ApiTokensResponse {
  success: boolean
  data: ApiToken[]
}

interface CreateTokenResponse {
  success: boolean
  token: string
  id: string
  name: string
}

export function useApiTokens() {
  return useQuery({
    queryKey: ["api-tokens"],
    queryFn: () => api.get<ApiTokensResponse>("/tokens"),
  })
}

export function useCreateApiToken() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (input: string | CreateTokenInput) =>
      api.post<CreateTokenResponse>("/tokens", typeof input === "string" ? { name: input } : input),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["api-tokens"] }),
  })
}

export function useRevokeApiToken() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => api.delete(`/tokens/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["api-tokens"] }),
  })
}
